import { GenericInput } from "../components/input/GenericInput";
import { GenericSelect } from "../components/select/GenericSelect";
import { FileUploader } from "../components/upload/FileUploader";
import {
  COMPONENT_TYPE,
  FILE_TYPE,
  HEADING_TYPE,
  SELECT_TYPE,
  SWITCH_TYPE,
  TEXT_TYPE,
  TEXT_VIEW_TYPE,
} from "../constants/webapp";
import { capitalize, changeToSnakeCase } from "./helpers";
import { GenericSwitch } from "../components/elements/Switch";

// create for fields
export function RenderForm({
  form,
  // index,
  // error,
  fields,
  onChange,
  // handleChange,
  updateFormValues,
  updateFormValue,
}) {
  return (
    <>
      {fields?.map((formField, i) => {
        let {
          type,
          props,
          value,
          onSelect,
          required,
          options = [],
          form_keys = [],
          visible = true,
          option_keys = [],
          error: customError,
          // children = [],
          // documentType = null,
          // multiple = false,
          label,
          id,
          component,
          ...rest
        } = formField || {};

        // setup field id
        id = id ?? changeToSnakeCase(label);
        label = label || capitalize(id);

        function getValue() {
          return value || form?.[id];
        }

        if (visible) {
          switch (type) {
            case TEXT_TYPE:
              return (
                <GenericInput
                  key={i}
                  label={label}
                  name={id}
                  onChange={onChange}
                  updateFormValue={updateFormValue}
                  value={getValue()}
                  required={required}
                  {...props}
                />
              );

            case SELECT_TYPE:
              return (
                <GenericSelect
                  key={i}
                  label={label}
                  value={getValue()}
                  options={options?.map((val) => {
                    return getOptions(val, option_keys, props);
                  })}
                  onChange={(val) => {
                    // multiple mode
                    if (props?.mode === "multiple")
                      updateFormValues({ [id]: val });
                  }}
                  onSelect={(val, obj) => {
                    if (props?.mode === "multiple") return;
                    // set selected value to form
                    return updateFormValues(
                      getFormValues(id, obj, form_keys, props?.valueInLabel)
                    );
                  }}
                  required={required}
                  {...props}
                />
              );

            case FILE_TYPE:
              return (
                <FileUploader
                  key={i}
                  images={form?.images}
                  setImages={(list) => updateFormValues({ images: list })}
                  label={label}
                  required={required}
                  {...props}
                />
              );

            case SWITCH_TYPE:
              return (
                <GenericSwitch
                  key={i}
                  updateFormValue={updateFormValue}
                  checked={getValue()}
                  field={id}
                  label={label}
                  docRef={form?.docRef}
                  {...props}
                />
              );

            case COMPONENT_TYPE:
              return <div key={i}>{component}</div>;

            case TEXT_VIEW_TYPE:
              return (
                <p key={i} className="font12 lightColor" {...props}>
                  {rest?.text}
                </p>
              );

            case HEADING_TYPE:
              return (
                <h3 key={i} {...props}>
                  {rest?.text}
                </h3>
              );

            default:
              break;
          }
        }

        return null;
      })}
    </>
  );

  // create form values
  function getFormValues(field, data, form_keys, valueInLabel) {
    var defaultObject = {
      [field]: data.value,
    };

    // set label to value
    if (valueInLabel) {
      defaultObject[field] = data.label;
    }

    // override default
    if (form_keys) {
      form_keys.map((value) => {
        if (value instanceof Object) {
          defaultObject = Object.assign(defaultObject, {
            // custom key/value pair
            [value.field_key]: data[value.value_key],
          });
        } else if (typeof value === "string") {
          defaultObject = Object.assign(defaultObject, {
            // same custom key/value pair
            [value]: data[value],
          });
        }

        return null;
      });
    }
    return defaultObject;
  }

  function getOptions(data, option_keys, props) {
    // default for picker
    var defaultObject = {
      label: data?.name,
      value: data?.id,
    };

    // override default for picker
    option_keys.map((key) => {
      if (key instanceof Object) {
        defaultObject = Object.assign(defaultObject, {
          [key.field_key]: data[key.value_key],
        });
      } else if (typeof key === "string") {
        option_keys.map((key) => {
          defaultObject = Object.assign(defaultObject, {
            [key]: data?.[key],
          });
          return null;
        });
      }
      return null;
    });

    // set value to label
    if (props?.labelInValue) {
      defaultObject.label = defaultObject.value;
    }

    // set label to value
    if (props?.valueInLabel) {
      defaultObject.value = defaultObject.label;
    }

    return defaultObject;
  }
}

// create a new form
// export function createForm(
//   sections = [],
//   form,
//   updateFormValues,
//   onChange,
//   error
// ) {
//   const alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
//   return (
//     <>
//       {sections.map((section, i) => {
//         const { title, fields, component } = section;
//         return (
//           <FormSection
//             title={title}
//             tag={`Section ${alphabet[i]}`}
//             index={i}
//             key={i}
//           >
//             {/* custom component */}
//             {component}
//             <RenderForm
//               form={form}
//               fields={fields}
//               updateFormValues={updateFormValues}
//               onChange={onChange}
//               error={error}
//             />
//           </FormSection>
//         );
//       })}
//     </>
//   );
// }

// construct the form/option value key pair
export function getFormValueKey(field_key, value_key) {
  return { field_key, value_key };
}

// phrase the value
export function phraseValue(value) {
  if (typeof value === "number") {
    return Number(value).toLocaleString();
  } else if (typeof value === "string") {
    return value?.toString();
  }
}
